interface Pet {
  id: number
  name: string
  ownerFirstName: string
  ownerLastName: string
  status: "care" | "completed" | "awaiting" | "scheduled"
  earnings: number
  consentSigned: boolean
  billing?: string
  clinicId: string
  createdAt: string
  updatedAt: string
}

class PetStore {
  private static instance: PetStore
  private currentPet: Pet | null = null
  private listeners: Set<(pet: Pet | null) => void> = new Set()

  private constructor() {
    // Load from localStorage on initialization
    if (typeof window !== 'undefined') {
      const savedPet = localStorage.getItem('currentPet')
      if (savedPet) {
        try {
          this.currentPet = JSON.parse(savedPet)
          console.log('PetStore: Loaded pet from localStorage:', this.currentPet?.name)
        } catch (error) {
          console.error('PetStore: Error loading pet from localStorage:', error)
          localStorage.removeItem('currentPet')
        }
      }
    }
  }

  static getInstance(): PetStore {
    if (!PetStore.instance) {
      PetStore.instance = new PetStore()
    }
    return PetStore.instance
  }

  getCurrentPet(): Pet | null {
    return this.currentPet
  }

  setCurrentPet(pet: Pet | null): void {
    this.currentPet = pet
    
    // Save to localStorage
    if (typeof window !== 'undefined') {
      if (pet) {
        localStorage.setItem('currentPet', JSON.stringify(pet))
        console.log('PetStore: Saved pet to localStorage:', pet.name)
      } else {
        localStorage.removeItem('currentPet')
        console.log('PetStore: Removed pet from localStorage')
      }
    }

    // Notify all listeners
    this.listeners.forEach(listener => listener(pet))
  }

  subscribe(listener: (pet: Pet | null) => void): () => void {
    this.listeners.add(listener)
    
    // Immediately call with current value
    listener(this.currentPet)
    
    // Return unsubscribe function
    return () => {
      this.listeners.delete(listener)
    }
  }

  clearCurrentPet(): void {
    this.setCurrentPet(null)
  }
}

export const petStore = PetStore.getInstance()
export type { Pet } 